import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useOtpService } from 'app/utils/services/otpService';
import useRedirectWithFormId from 'app/utils/customHooks/useRedirectWithFormId';

interface Props {
  setModalOtp?: (newOtp: string) => void;
}

const useOTP = (props: Props) => {
  const { setModalOtp } = props;
  const { t } = useTranslation();
  const [otp, setOtp] = useState<string>();

  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;

  const { dataOtp, otpMutation } = useOtpService();
  const { handleRedirect } = useRedirectWithFormId();
  const { handleSubmit } = useForm({});

  useEffect(() => {
    if (dataOtp !== undefined) {
      handleRedirect({ ...dataOtp, tab: data.tab });
    }
  }, [dataOtp]);
  const handleChange = (newOtp: string) => {
    setOtp(newOtp);
    setModalOtp(newOtp);
  };

  const resentOtp = () => {
    otpMutation({ data: { form_id: 'renew_otp' }, url: `${data?.path_url}?business_key=${data?.business_key}` });
  };

  const handleOnSubmit = () => {
    otpMutation({ data: { otp }, url: `${data?.path_url}?business_key=${data?.business_key}` });
  };

  const goBack = () => {
    navigate(-1);
  };

  const handleSubmitForm = handleSubmit(handleOnSubmit);

  return { t, otp, data, dataOtp, handleChange, handleSubmitForm, goBack, resentOtp };
};

export default useOTP;
